import { UntypedFormGroup } from '@angular/forms'

export class AnalyticsStub {
  private readonly PAGE = 'SignUp'

  public pageView(depth2: string, depth3?: string): void {
    // no op
  }

  public seEvent(action: string, eventType=8): void {
    // no op
  }

  public trackError(action: string, page=this.PAGE): void {
    this.seEvent(action, 1)
  }

  public trackFormErrors(form: UntypedFormGroup): void {
    this.trackError('FormError')
   }

  public push(): void {
    // no op
  }
}
